import React from 'react';
import { FiDroplet } from 'react-icons/fi';
import { Coffee } from 'lucide-react';
import tnsLogo from '../../../assets/images/tnslogo.png';

const OPTHomeScreen = ({ onEnterAmount }) => (
  <div className="bg-white text-gray-800 h-full flex flex-col overflow-hidden">
    {/* Header Bar */}
    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0">
      <div className="flex items-center space-x-2">
        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
          <FiDroplet className="w-4 h-4 text-white" />
        </div>
        <span className="font-bold text-gray-800 text-base">Fuel Co</span>
      </div>
      <div className="flex items-center space-x-1.5">
        <span className="text-xs text-gray-400">Powered by</span>
        <img src={tnsLogo} alt="TNS" className="h-5" />
      </div>
    </div>

    {/* Main Content - fills remaining space */}
    <div className="flex-1 flex flex-col items-center justify-center px-4">
      {/* Instruction */}
      <h2 className="text-2xl font-bold text-gray-800 text-center mb-5">
        Select <span className="text-blue-600">amount</span> or lift <span className="text-blue-600">nozzle</span> to begin
      </h2>

      {/* Action Cards */}
      <div className="grid grid-cols-3 gap-3 w-full">
        {/* Enter Amount Card */}
        <button
          onClick={onEnterAmount}
          className="bg-blue-600 rounded-xl p-6 text-center hover:bg-blue-700 transition-all group shadow-sm"
        >
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="text-white font-bold text-sm mb-1">Enter amount</div>
          <div className="text-white/60 text-xs">Insert or tap payment card</div>
        </button>

        {/* Redeem Card */}
        <div className="bg-blue-50 border-2 border-blue-700 rounded-xl p-6 text-center shadow-sm">
          <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
            <svg className="w-6 h-6 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
          </div>
          <div className="text-blue-800 font-bold text-sm mb-1">Redeem</div>
          <div className="text-blue-600 text-xs">Loyalty points</div>
        </div>

        {/* Promo Card - Coffee deal */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 flex flex-col items-center justify-center shadow-sm">
          <Coffee className="w-8 h-8 text-amber-700 mb-1" />
          <div className="text-xs font-semibold text-gray-800">Coffee & Croissant</div>
          <div className="text-lg font-black text-amber-600 my-0.5">$5.99</div>
          <div className="text-[10px] text-gray-500">Grab one inside</div>
        </div>
      </div>

      {/* Payment logos - clean and understated */}
      <div className="flex items-center space-x-3 mt-5">
        <span className="text-xs font-bold text-gray-400 tracking-wide">VISA</span>
        <span className="text-xs font-bold text-gray-400 tracking-wide">Mastercard</span>
        <span className="text-xs font-bold text-gray-400 tracking-wide">AMEX</span>
        <span className="text-xs font-bold text-gray-400 tracking-wide">Discover</span>
        <span className="text-xs font-bold text-gray-400 tracking-wide">JCB</span>
        <span className="text-xs font-bold text-gray-400 tracking-wide">UPI</span>
        <span className="text-xs text-gray-300">|</span>
        <span className="text-xs font-medium text-gray-400">Apple Pay</span>
        <span className="text-xs font-medium text-gray-400">Google Pay</span>
      </div>
    </div>
  </div>
);

export default OPTHomeScreen;
